import {ComparisonDate} from 'common/query-builder/query-block/time-comparison-menu/types';
import {DateRangeAttributes} from 'common/widgets/date-range-picker/models/date-range';

export type CanvasProps = {
  projectId: number;
  workspaceId: number;
  userId: number;
  canvasId: number;
  onError: (error: Error) => void;
};

export enum Visibility {
  METRIC_VALUE = `metric_value`,
  SPARKLINE = `sparkline`,
  CORRELATION = `correlation`,
}

export type TimeRangeAndComparison = {
  timeRange: DateRangeAttributes;
  timeComparison: ComparisonDate;
  title: string;
};
